import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,

};

export const getJobRequireList = createAsyncThunk(
    "getJobRequireList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/job/job-requirement-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const JobRequireSlice = createSlice({
    name: "JobRequireSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getJobRequireList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getJobRequireList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getJobRequireList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default JobRequireSlice.reducer;
